import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { ScheduleHero } from './schedule/ScheduleHero';
import { ScheduleTable } from './schedule/ScheduleTable';
import { ScheduleCTA } from './schedule/ScheduleCTA';
export function SchedulePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-820">
      <Navigation data-id="element-821" />
      <ScheduleHero data-id="element-822" />
      <ScheduleTable data-id="element-823" />
      <ScheduleCTA data-id="element-824" />
      <TrialOfferCTA data-id="element-825" />
      <Footer data-id="element-826" />
    </div>;
}